export default __webpack_public_path__ + "static/media/ReplaceFile.9700787d.svg";